import { memo } from 'react';
import styled from 'styled-components';

const StyledTableFooter = styled.tfoot`
  margin: 0px;
  padding: 0px;
  background-color: #dcdbc1;
  color: #000000;
  td {
    border-width: 0px;
    color: #000000;
    padding: 20px !important;
    font-family: 'trebuchet MS', 'Lucida sans', Arial;
    font-weight: 600;
    :first-child {
      background-color: #545454;
      border-bottom-left-radius: inherit;
    }
    :last-child {
      border-bottom-right-radius: inherit;
    }
  }
`;

const TableFooter = memo(({ children }) => (
  <StyledTableFooter>{children}</StyledTableFooter>
));

export default TableFooter;
